
    import { CommonEnvironment } from "./environment.common";
    export const environment = {
        ...CommonEnvironment,
        mock: false,
        production: false,
        brand: 'nb',
        stage: 'local',
        appUrl: 'https://localhost:4200/',
        apiBaseUrl: 'https://api.dev.consent.norisbank.de/',
        forgerock: {
            clientId: '173432-1_norisbank_consentAdministrationClient',
            redirectUri: 'https://localhost:4200/authredirect',
            scope: 'openid',
            realmPath: 'root/norisbank',
            serverConfig: {
                baseUrl: 'https://api.dev.olb.norisbank.de/oneid/am',
                timeout: 6000
            }
        }
    }
